import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"

import Button from "../../common/Button"
import PatientListVerticalItem from "./PatientListVerticalItem"
import { workqueueActions } from "../../../store/workqueue"
import Pagination from "../../work_queues/pages/pagination/Pagination"
import { retrieveAllWorkQs } from "../../../lib/systemData"
import MockLoadingBlock from "../../mock/MockLoadingBlock"

import classes from './PatientListVertical.module.css'

const DetailsVerticalList = ({passApi}) => {
    const dispatch = useDispatch()
    let { workqSlug } = useParams();

    const selectedWorkQueue = useSelector((state) => state.workqueue.selectedWorkQueue);
    const navigate = useNavigate();

    const backToDetailedList = () => {
        navigate(`/work-queues/${selectedWorkQueue?.slug}`);
    }

    const data = useSelector(state => state.filter.currentpagedata)
    const loading = useSelector(state => state.filter.loading)
    const hasRows = data?.data?.length > 0

    useEffect(() => {
        if (!selectedWorkQueue) {
            let workqLists = retrieveAllWorkQs()
            dispatch(workqueueActions.setSelectedWorkQueue(workqLists?.find(item => item.slug == workqSlug)))
        }
    }, [selectedWorkQueue])

    return <div className={classes.vertical_list}>
        <div className={classes.list_header}>
            <Button click={backToDetailedList} btnStyle="btn_grey" width={'full'} bypassisCaseArchived={true}>
                <i className="ti ti-list"></i>
                View Detailed List
            </Button>
        </div>
        <ul className={classes.list_body}>

            {loading && !hasRows && Array.from({ length: 6 }).map((_, i) => (
                <li key={`sk-${i}`}>
                    <MockLoadingBlock height={56} />
                </li>
            ))}
            {hasRows && data.data.map((item) => (
                <PatientListVerticalItem key={item.case.id} data={item} selectedPatient={null} isVerification={selectedWorkQueue?.name == 'Verification' || selectedWorkQueue?.name == 'Verifications Q'}/>
            ))}
            {!loading && !hasRows && <li>
                <div className={classes.no_item_found}>No Items Found!</div>    
            </li>}
        </ul>

        {data && data.meta && <div className={classes.pagination_container}>
            <Pagination data={data} isSimple={true} apiType={selectedWorkQueue?.queue} hidePerPage={true}/>    
        </div>}
    </div>
}

export default DetailsVerticalList